import React, { useEffect, useRef, useState } from 'react'
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import DataTable, { TableStyles } from 'react-data-table-component';
import { Button } from '@app/components';
import { getAllActiveFranchise } from '@app/services/franchise';
import Select from "react-select";
import AddStudentCountsModal from './AddStudentCountsModal';
import { deleteStudentCount, getAllByPagination, getDefaulters } from '@app/services/studentCount';
import { confirmAlert } from 'react-confirm-alert';
import UpdateStudentCountsModal from './UpdateStudentCountsModal';
import moment from 'moment';
import fileDownload from 'js-file-download';
import ExcelJS from "exceljs/dist/es5/exceljs.browser";
import { Link } from 'react-router-dom';
import { encodeId } from '@app/helpers/base64url';

const ListStudentCounts = () => {

    const selectRef = useRef(null);
    const [studentCounts, setStudentCounts] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortField, setSortField] = useState('');
    const [sortDirection, setSortDirection] = useState('');
    const [search, setSearch] = useState({franchise_order_id:'', franchise: '', month: '', year: (new Date().getFullYear()) + ''});
    const [franchises, setFranchises] = useState([]);
    const canAccess = useSelector((state: any) => state.auth.permissions?.['student-count']);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showUpdate, setShowUpdate] = useState(false);
    const handleCloseUpdate = () => setShowUpdate(false);
    const handleShowUpdate = () => setShowUpdate(true);
    const [updateStudCountPayload, setUpdateStudCount] = useState({franchise_id: '', month: '', year: '', maths: '', english: '', science: ''});

    const months = [{id: 1, name:'January'}, {id: 2, name:'February'}, {id: 3, name:'March'}, 
                    {id: 4, name:'April'}, {id: 5, name:'May'}, {id: 6, name:'June'},
                    {id: 7, name:'July'},{id: 8, name:'August'},{id: 9, name:'September'},
                    {id: 10, name:'October'}, {id: 11, name:'November'}, {id: 12, name:'December'}];
    const years = Array.from({ length: 5 }, (_, index) => new Date().getFullYear() - index );
    
    const customStyle: TableStyles = {
        head: {
            style: {
                color: "#5E5873",
                fontSize: "13px",
                fontWeight: 900,
            },
        },
        headCells: {
            style: {
                borderColor: "#E9ECEF",
                textTransform: "uppercase",
                letterSpacing: "1px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#F7F7F8",
                minHeight: "44px",
                fontWeight: 500,
            },
        },
    };

    const customStylesSelect = {
        dropdownIndicator: () => ({
            display: 'none',
        }),
    }

    useEffect(() => {
        getAllByPaginationData(1, perPage, sortField, sortDirection);
    },[search]);

    useEffect(() => {
        getAllActiveFranchiseData();
    },[]);

    const getAllByPaginationData = async (page, perPage, sortField, sortDirection) => {
        try {
            setLoading(true);
            const usersResp = await getAllByPagination(page, perPage, sortField, sortDirection, search);
            if (usersResp.success === true) {
                setLoading(false);
                setStudentCounts(usersResp.collections.data);
                setTotalRows(usersResp?.collections?.pagination?.total);
            } else {
                setLoading(false);
                toast.error(usersResp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.response?.message || 'Failed');
        }
    };

    const getAllActiveFranchiseData = async () => {
        try {
            const resp = await getAllActiveFranchise();
            if (resp?.success === true) {
                setFranchises(resp?.collections.filter((franchise) => franchise.enabled_student_count == true));
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.response?.message || 'Failed');
        }
    };

    const columns = [
        {
            name: '#Txn Id',
            selector: (row: { franchise_order_id: string; }) => `#${row.franchise_order_id}`,
            sortable: true,
            sortField: 'franchise_order_id',
            // width: '8%',
            wrap: true
        },
        {
            name: 'Franchise',
            selector: (row: { name: string; }) => row.name,
            sortable: true,
            sortField: 'franchise_id',
            wrap: true,
        },
        {
            name: 'Postcodes',
            selector: (row: { postcodes: string; }) => (row.postcodes).length > 0 ? ( Array.prototype.map.call(row.postcodes, function(postcode) { return postcode.name; }).join(", ") ) : '',
            wrap: true,
        },
        {
            name: 'Month',
            selector: (row: { month: any; }) => { return (months.find(obj => +row.month === obj.id))?.name ?? '---' },
            sortable: true,
            sortField: 'month',
        },
        {
            name: 'Year',
            selector: (row: { year: string; }) => row.year,
            sortable: true,
            sortField: 'year',
        },
        {
            name: 'Mathematics',
            selector: (row: { maths: string; }) => row.maths ?? '---',
            // sortable: true,
            // sortField: 'maths',
            wrap: true,
        },
        {
            name: 'English',
            selector: (row: { english: string; }) => row.english ?? '---',
            // sortable: true,
            // sortField: 'english',
            wrap: true,
        },
        {
            name: 'Science',
            selector: (row: { science: string; }) => row.science ?? '---',
            // sortable: true,
            // sortField: 'science',
            wrap: true,
        },
        {
            name: 'Total',
            selector: (row: { total: string; }) => row.total ?? '---',
            // sortable: true,
            // sortField: 'total',
            wrap: true,
        },
        {
            name: 'Submission Date',
            selector: (row: { succeeded_at: string; }) => row.succeeded_at,
            cell: (row: { succeeded_at: string; }) => (
                row.succeeded_at ? moment(row.succeeded_at).format('DD/MM/YYYY') : '---'
            ),
            sortable: true,
            sortField: 'succeeded_at',
            // wrap: true
        },
        {  
            name: 'Action',
            cell: (row) => (
              <>
                {/* { canAccess?.['edit-student-count'] &&
                    <a href='#' onClick={ (e) => { handleUpdateStudCount({postcodes: row.postcodes, franchise_id: row.franchise_id, month: row.month, year: row.year, maths: row.maths, english: row.english, science: row.science, total: row.total}) }} data-toggle="tooltip" title="Edit Student Count">
                        <i className="fas fa-pen mr-2"/>
                    </a>
                }
                { canAccess?.['delete-student-count'] &&
                    <a href='#' onClick={ (e) => { deleteConfirm(e, {franchise_id: row.franchise_id, month: row.month, year: row.year})} }>
                        <i className="fas fa-trash mr-2"/>
                    </a>
                } */}
                { canAccess?.['view-transaction'] && 
                    ( row.franchise_order_id > 0 &&
                        <Link
                            to={`/student-counts/view/${encodeId(row.franchise_order_id)}`}
                            role="button"
                            state={{ id: row.franchise_order_id }}
                            data-toggle="tooltip" title="View Transaction Details"
                        ><i className="fas fa-eye mr-2"/></Link>
                    )
                }
              </>
            ),
            omit: !(canAccess?.['view-transaction'])
        },
    ];

    const deleteConfirm = (e, payload) => {
        confirmAlert({
            title: 'Confirm to submit',
            message: 'Are you sure to delete this?',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => deleteStudentCountAPI(payload)
                },
                {
                    label: 'No',
                    onClick: () => {}
                }
            ]
        });
        e.preventDefault();
    };

    const deleteStudentCountAPI = async (id) => {
        try {
            setLoading(true);
            const resp = await deleteStudentCount(id);
            if(resp.success === true){
                toast.success(resp?.message);
                setLoading(false);
                getAllByPaginationData(currentPage, perPage, sortField, sortDirection);
            }else{
                toast.error(resp?.errors[0]?.msg);
                setLoading(false);
            }
          } catch (error: any) {
            setLoading(false);
            toast.error(error.response.message || 'Failed');
          }
    };

    const handleUpdateStudCount= async(payload) => {
        handleShowUpdate();
        payload.postcodes = (payload.postcodes).length > 0 ? ( Array.prototype.map.call(payload.postcodes, function(postcode) { return postcode.name; }).join(", ") ) : ''
        setUpdateStudCount(payload)
    }

    const handlePageChange = page => {
        getAllByPaginationData(page, perPage, sortField, sortDirection);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        getAllByPaginationData(page, newPerPage, sortField, sortDirection);
        setPerPage(newPerPage);
    };

    const handleSort = async (column, sortDirection) => {
        setSortField(column.sortField);
        setSortDirection(sortDirection);
        getAllByPaginationData(currentPage, perPage, column.sortField, sortDirection);
    };

    const handleResetFilter = async () => {
        selectRef.current.setValue('');
        setSearch({franchise_order_id:'', franchise: '', month: '', year: ''});
    };

    const onChangeFranchise = (option) => {
        setSearch({ ...search, franchise: option?.id ? option?.id : '' });
    };

    const handleFetchAgain = () => {
        getAllByPaginationData(currentPage, perPage, sortField, sortDirection)
    }

    const exportCSV = async() => {
        let records = await getAllByPagination(1, totalRows, sortField, sortDirection, search)

        if(records?.collections?.data.length === 0){
            toast.error('Records not found.')
            return;
        }

        const workbook = new ExcelJS.Workbook();
        workbook.addWorksheet("Student Counts");
        const worksheet = workbook.getWorksheet('Student Counts');

        worksheet.columns = [
            { header: "Franchise", key: "name", width: 26 },
            { header: "Kashflow Order Account", key: "kashflow_order_account", width: 22 },
            { header: "Month", key: "month", width: 14 },
            { header: "Year", key: "year", width: 10 },
            { header: "Maths (Qty)", key: "maths", width: 12 },
            { header: "Maths Rate (excl VAT)", key: "maths_rate", width: 20 },
            { header: "English (Qty)", key: "english", width: 12 },
            { header: "English Rate (excl VAT)", key: "english_rate", width: 20 },
            { header: "Science (Qty)", key: "science", width: 12 },
            { header: "Science Rate (excl VAT)", key: "science_rate", width: 20 },
            { header: "Total (Qty)", key: "total", width: 12 },
            { header: "Net Amount (excl VAT)", key: "net_price", width: 20 },
            { header: "VAT Amount", key: "vat_price", width: 14 },
            { header: "Total Amount (incl VAT)", key: "total_price", width: 20 },
            { header: "Submission Date", key: "succeeded_at", width: 18 },
            { header: "Transaction ID", key: "franchise_order_id", width: 16 },
            { header: "Stripe Payment ID", key: "stripe_payment_id", width: 30 }
        ];

        const formatVal = (val) => {
            if (val === null || val === undefined || val === '') return '---';
            const num = Number(val);
            return isNaN(num) ? '---' : num;
        };

        const formattedRows = (records?.collections?.data).map( (row) => {
            // VAT may come as vat_price, vat, or be derived from total - net
            let vatVal = formatVal(row.vat_price);
            if (vatVal === '---') {
                vatVal = formatVal(row.vat);
            }
            if (vatVal === '---') {
                const net = Number(row.net_price);
                const total = Number(row.total_price);
                if (!isNaN(net) && !isNaN(total) && row.net_price !== null && row.net_price !== '' && row.total_price !== null && row.total_price !== '') {
                    vatVal = Number((total - net).toFixed(2));
                }
            }
            return {
                ...row,
                month: (months.find(obj => +row.month === obj.id))?.name ?? '---',
                maths_rate: formatVal(row.maths_rate),
                english_rate: formatVal(row.english_rate),
                science_rate: formatVal(row.science_rate),
                net_price: formatVal(row.net_price),
                vat_price: vatVal,
                total_price: formatVal(row.total_price),
                succeeded_at: row.succeeded_at ? moment(row.succeeded_at).format('DD/MM/YYYY') : '---'
            };
        });

        // Group rows by transaction id (franchise_order_id)
        const groups = new Map<string, any[]>();
        formattedRows.forEach((r) => {
            const key = (r.franchise_order_id !== null && r.franchise_order_id !== undefined && r.franchise_order_id !== '') ? r.franchise_order_id.toString() : 'N/A';
            if (!groups.has(key)) groups.set(key, []);
            groups.get(key).push(r);
        });

        const numOr0 = (v) => (typeof v === 'number' ? v : 0);
        const round2 = (v) => Number(v.toFixed(2));

        const currencyKeys = ['maths_rate', 'english_rate', 'science_rate', 'net_price', 'vat_price', 'total_price'];
        const subtotalRowNumbers = new Set<number>();

        groups.forEach((groupRows, key) => {
            worksheet.addRows(groupRows);

            // Compute subtotal for the group
            let sumMaths = 0, sumEnglish = 0, sumScience = 0, sumQty = 0, sumNet = 0, sumVat = 0, sumTotal = 0;
            groupRows.forEach((r) => {
                sumMaths += numOr0(Number(r.maths));
                sumEnglish += numOr0(Number(r.english));
                sumScience += numOr0(Number(r.science));
                sumQty += numOr0(Number(r.total));
                sumNet += numOr0(r.net_price);
                sumVat += numOr0(r.vat_price);
                sumTotal += numOr0(r.total_price);
            });

            const subtotal = worksheet.addRow({
                name: key === 'N/A' ? 'Subtotal (No Transaction)' : `Transaction #${key} — Subtotal`,
                maths: sumMaths,
                english: sumEnglish,
                science: sumScience,
                total: sumQty,
                net_price: round2(sumNet),
                vat_price: round2(sumVat),
                total_price: round2(sumTotal)
            });
            subtotalRowNumbers.add(subtotal.number);
        });

        // Style the header row
        const headerRow = worksheet.getRow(1);
        headerRow.height = 22;
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11 };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E5C8A' } };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            cell.border = {
                top: { style: 'thin', color: { argb: 'FFBFBFBF' } },
                left: { style: 'thin', color: { argb: 'FFBFBFBF' } },
                bottom: { style: 'thin', color: { argb: 'FFBFBFBF' } },
                right: { style: 'thin', color: { argb: 'FFBFBFBF' } }
            };
        });

        // Style data + subtotal rows
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1) return;
            const isSubtotal = subtotalRowNumbers.has(rowNumber);
            const isEven = rowNumber % 2 === 0;
            row.eachCell((cell, colNumber) => {
                const colKey = worksheet.columns[colNumber - 1]?.key;
                cell.border = {
                    top: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                    left: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                    bottom: { style: 'thin', color: { argb: 'FFE0E0E0' } },
                    right: { style: 'thin', color: { argb: 'FFE0E0E0' } }
                };

                if (isSubtotal) {
                    cell.font = { bold: true, color: { argb: 'FF333333' } };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF2CC' } };
                } else if (isEven) {
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3F6FA' } };
                }

                if (currencyKeys.includes(colKey)) {
                    if (typeof cell.value === 'number') {
                        cell.numFmt = '£#,##0.00';
                        cell.alignment = { horizontal: 'right' };
                    } else {
                        cell.alignment = { horizontal: 'center' };
                    }
                } else if (['maths', 'english', 'science', 'total', 'year'].includes(colKey)) {
                    cell.alignment = { horizontal: 'center' };
                }
            });
        });

        // Freeze header row
        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        let filename = 'Student-Counts-' + moment().format('DD-MMM-YYYY') + '.xlsx';
        workbook.xlsx.writeBuffer().then(function(buffer) {
            fileDownload(buffer, filename, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        });
    };

    const exportDefaulterCSV = async() => {

        if(search.year == ''){
            toast.error('Please select a year to export the defaulters.')
            return
        }

        let records = await getDefaulters(search);

        if(records?.collections.length === 0){
            toast.error('Records not found.');
            return;
        }

        // if(search?.year == '2023'){
        //     let filterArr = records?.collections.filter((obj) => {
        //         return obj.month == 'November' || obj.month == 'December'
        //     })
            
        //     if(filterArr.length === 0){
        //         toast.error('Records not found.');
        //         return;
        //     }
        // }

        const workbook = new ExcelJS.Workbook();
        workbook.addWorksheet("Sheet1");
        const worksheet = workbook.getWorksheet('Sheet1');
        worksheet.columns = [
            { header: "Franchise", key: "name" },
            { header: "Month", key: "month" },
            { header: "Year", key: "year" }
        ];

        // (records?.collections?.data).map( (row) => {
        //     row.month = (months.find(obj => +row.month === obj.id))?.name ?? '---'
        // })
        worksheet.addRows(records?.collections);
        let filename = 'Defaulters-' + moment().format('DD-MMM-YYYY') + '.csv';
        workbook.csv.writeBuffer().then(function(buffer) {
            fileDownload(buffer, filename);
        });
    }

    return (
        <div>
            <div>
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Submit Student Subject Count</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Submit Student Subject Count</li>
                                </ol>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div style={{ marginBottom: 10 }} className="row">
                                    
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Submit Student Subject Count</h3>
                                        <div className="col-lg-12 text-right">
                                            { canAccess?.['export-student-count'] &&
                                                <Button className="btn btn-success mr-2" isLoading={isLoading} onClick={exportCSV}><i className="fas fa-file-csv"></i> Export Student Count </Button>
                                            }
                                            { canAccess?.['create-student-count'] &&
                                                // <a className="btn btn-primary" onClick={handleShow} > + Add New </a>
                                                <Link className="btn btn-primary" to="/submit-student-counts" > Submit Student Count </Link>
                                            }
                                        </div>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-sm-2">
                                                <input type="number" name='franchise_order_id' className="form-control" value={search.franchise_order_id} onChange={(e) => setSearch({ ...search, franchise_order_id: e.target.value })} placeholder="Search By Txn Id" />
                                            </div>
                                            <div className="col-sm-3">
                                                <Select
                                                    ref={selectRef}
                                                    name="franchiseId"
                                                    placeholder="Search By Franchise"
                                                    options={franchises}
                                                    getOptionValue={(option)=>`${option['id']}`}
                                                    getOptionLabel={(option)=> option['name'] }
                                                    onChange={ (option) => {onChangeFranchise(option)}}
                                                    isClearable={true}
                                                    className="basic-single"
                                                    classNamePrefix="select"
                                                    // onInputChange={ (option) => {onChangeFranchise(option)}}
                                                    // value={search.franchiseId}
                                                    // styles={customStylesSelect}
                                                />
                                            </div>
                                            <div className="col-sm-2">
                                                <select
                                                    className="form-control"
                                                    name="month"
                                                    onChange={(e) => setSearch({ ...search, month: e.target.value })} 
                                                    value={search.month}
                                                >
                                                    <option value="">All Months</option>
                                                    {months.map((obj) => (
                                                        <option key={obj.name} value={obj.id}>
                                                            {obj.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col-sm-2">
                                                <select
                                                    className="form-control"
                                                    name="year"
                                                    onChange={(e) => setSearch({ ...search, year: e.target.value })} 
                                                    value={search.year}
                                                >
                                                    <option value="">All Years</option>
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='col-sm-3'>
                                                <Button type="submit" isLoading={isLoading} onClick={handleResetFilter} className="btn btn-warning mr-2">Reset Filter</Button>
                                                { canAccess?.['export-defaulters'] &&
                                                    <Button type="submit" isLoading={isLoading} onClick={exportDefaulterCSV} className="btn btn-success my-1">Export Defaulters</Button>
                                                }
                                            </div>
                                        </div>

                                        <DataTable
                                            columns={columns}
                                            data={studentCounts}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationDefaultPage={currentPage}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            paginationPerPage={perPage}
                                            paginationRowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                                            progressPending={isLoading}
                                            sortServer
                                            onSort={handleSort}
                                            customStyles={customStyle}
                                        />
                                    </div>
                                    {/* /.card-body */}
                                </div>
                            </div>
                            {/* /.col */}
                        </div>
                        {/* /.row */}
                    </div>
                    {/* /.container-fluid */}
                </section>
                <AddStudentCountsModal
                    show={show}
                    handleClose={handleClose}
                    franchises={franchises}
                    handleFetchAgain={handleFetchAgain}
                />
                <UpdateStudentCountsModal
                    show={showUpdate}
                    handleClose={handleCloseUpdate}
                    franchises={franchises}
                    handleFetchAgain={handleFetchAgain}
                    payload={updateStudCountPayload}
                />
                {/* /.content */}
            </div>

        </div>
    )
};

export default ListStudentCounts;
